import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { Colors } from '@gripp/shared-ui';
import { StyleSheet, Text, View } from 'react-native';
import { ModalButton } from '../../shared/components/modalButton';
import { EditFileForm } from './editFileForm';

type EditFileMenuProps = {
  label: any;
  fileId: string;
};

export const EditFileMenu = (props: EditFileMenuProps) => {
  return (
    <View style={styles.fileEditContainer}>
      <ModalButton
        label=""
        omitPadding={true}
        customButton={
          <View style={{ flexDirection: 'row' }}>
            <MaterialCommunityIcons
              name="pencil-outline"
              color={Colors.blackText}
              size={16}
              style={styles.icon}
            />
            <Text style={styles.label}>{props.label}</Text>
          </View>
        }
        buttonStyle={styles.editFileButton}
        modalComponent={({ onComplete }) => {
          return (
            <EditFileForm
              onComplete={onComplete}
              fileId={props.fileId}
            />
          );
        }}
        containerStyle={styles.modalContainer}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  fileEditContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 20,   
    width: 151, 
    height: 32,
    backgroundColor: Colors.white,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: Colors.grayDivider,
  },
  editFileButton: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: 149,
    height: 30,

    borderRadius: 16,
  },
  icon: {
    marginRight: 4,
  },
  label: {
    fontSize: 16,
    fontWeight: '500',
    letterSpacing: -0.25,
  },
  modalContainer: {
    alignSelf: 'center',
    backgroundColor: Colors.primaryGrayBackground,
    borderRadius: 10,
    width: 560,
  },
});
